import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';

export const MigrationHero: React.FC = () => (
  <Box position="relative" overflow="hidden" bg="gray.900" color="white" flexShrink={0}>

    <VStack position="relative" align="start" gap={4} px={{ base: 5, md: 9 }} pt={{ base: 6, md: 9 }} pb={{ base: 6, md: 8 }} pr={{ base: 16, md: 36 }}>
      <Text fontSize="xs" fontWeight="bold" letterSpacing="wider" color="gray.300" textTransform="uppercase">
        Nouveau
      </Text>

      <Text
        as="h2"
        fontSize={{ base: '2xl', md: '4xl' }}
        fontWeight="black"
        fontStyle="italic"
        textTransform="uppercase"
        lineHeight="1"
        letterSpacing="-0.01em"
      >
        Ton plan, 100 % flexible.
      </Text>

      <Text fontSize="sm" color="gray.300" lineHeight="tall">
        Ton plan se cale désormais sur tes véritables dispo : tu choisis combien de séances tu fais, et quels
        jours. 30 secondes, modifiable à tout moment dans Mon compte.
      </Text>
    </VStack>
  </Box>
);

export default MigrationHero;
